import React, {useState} from 'react';
import { connect } from 'react-redux';
//import { withRouter } from 'react-router-dom';
import { ThemeProps, RTLProps } from '@/shared/prop-types/ReducerProps';
import classnames from 'classnames';

import { Modal, ModalHeader, ModalBody, Nav, NavItem, NavLink, TabContent, TabPane, Button, ButtonToolbar } from 'reactstrap';
import AddProgramUserForm from './AddProgramUserForm'
import AssignUser from './AssignUser'
import "./style.scss";
import "../components/style.scss";

const AddProgramUserModal = ({organization, program, isOpen, setOpen, toggle, theme, rtl, setTrigger}) => {
    const [activeTab, setActiveTab] = useState('1');
    const tabToggle = (tab) => {
        if (activeTab !== tab) setActiveTab(tab);
    };
    const modalSubtitle = activeTab === '1'
        ? `Create a new user directly inside ${program?.name}.`
        : `Assign existing users into ${program?.name} without leaving this page.`;
    if(!organization?.id || !program?.id) return 'Loading...'
    return (
        <Modal className={`modal-program manager-program-modal manager-program-modal--wide modal-lg ${theme.className} ${rtl.direction}-support`} isOpen={isOpen} toggle={toggle} style={{width: '1024px'}}>
            <ModalHeader tag="div" className="manager-program-modal__header">
                <div className="manager-program-modal__header-row">
                    <div className="manager-program-modal__header-copy">
                        <h3 className="manager-program-modal__title">Program Users</h3>
                        <p className="manager-program-modal__subtitle">{modalSubtitle}</p>
                    </div>
                    <ButtonToolbar className="manager-program-modal__actions">
                        <Button outline color="primary" onClick={toggle}>Close</Button>
                    </ButtonToolbar>
                </div>
            </ModalHeader>
            <ModalBody className="manager-program-modal__body">

                <div className="tabs__wrap manager-program-modal__tab-shell">
                    <Nav tabs className="manager-program-modal__tabs">
                        <NavItem>
                            <NavLink
                                className={classnames({ active: activeTab === '1' })}
                                onClick={() => tabToggle('1')}
                            >
                                New User
                            </NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink
                                className={classnames({ active: activeTab === '2' })}
                                onClick={() => tabToggle('2')}
                            >
                                Available Users
                            </NavLink>
                        </NavItem>
                    </Nav>
                    <TabContent activeTab={activeTab} className="manager-program-modal__tab-panel">
                        <TabPane tabId="1">
                            <AddProgramUserForm organization={organization} program={program} toggle={toggle} setTrigger={setTrigger} />
                        </TabPane>
                        <TabPane tabId="2">
                            <AssignUser organization={organization} program={program} setTrigger={setTrigger} toggleParent={toggle} />
                        </TabPane>
                    </TabContent>
                </div>
               
            </ModalBody> 
        </Modal>
    )
}
AddProgramUserModal.propTypes = {
    theme: ThemeProps.isRequired,
    rtl: RTLProps.isRequired
};
  
export default connect((state) => ({
    theme: state.theme,
    rtl: state.rtl
}))(AddProgramUserModal);
